module.exports = __webpack_public_path__ + "img/STX Finland logo.8a405651.png";